import store from '@/store'

export default (to, from, next) => {
  if (store.getters['auth/check']) {
    next({ name: 'users' })
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/router/middleware/guest.js